import { createContext } from 'react';

const initialContext: any = {
  version: null,
  isDebrandedVersion: null,
  testName: 'default',
  configFile: 'default',
  data: {},
  features: {},
  updateConfigData: () => {},
  country: null,
  isGlobal: false
};
const ConfigContext = createContext(initialContext);

export default ConfigContext;
